import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Col, Card, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  FLOWS_SUCCESS,
  FLOWS_FAILED,
  flowClearState as flowClearStateAction,
  getAsyncData as getAsyncDataAction,
} from '../../../../redux/actions/flowsAction';
import WizardFormOne from './WizardFormOne';
import WizardFormTwo from './WizardFormTwo';
import WizardFormThree from './WizardFormThree';
import WizardFormFour from './WizardFormFour';
import WizardFormFive from './WizardFormFive';
import WizardFormSix from './WizardFormSix';
import WizardFormSeven from './WizardFormSeven';
// import WizardFormEight from './WizardFormEight';
// import WizardFormNine from './WizardFormNine';
import { FullWideNotification } from '../../../../shared/components/Notification';

class WizardForm extends PureComponent {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncStatus: PropTypes.string.isRequired,
    submitStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    getAsyncData: PropTypes.func.isRequired,
    flowClearState: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const { getAsyncData } = this.props;
    getAsyncData();
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, history } = nextProps;

    if (submitStatus === FLOWS_SUCCESS) {
      history.push('/flows');
    } else if (submitStatus === FLOWS_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { flowClearState } = this.props;
    flowClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  nextPage = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  };

  render() {
    const { asyncData, asyncStatus } = this.props; // showNotification
    const { page } = this.state;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 1</p>
                </div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 2</p>
                </div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 3</p>
                </div>
                <div className={`wizard__step${page === 4 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 4</p>
                </div>
                <div className={`wizard__step${page === 5 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 5</p>
                </div>
                <div className={`wizard__step${page === 6 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 6</p>
                </div>
                <div className={`wizard__step${page === 7 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 7</p>
                </div>
              </div>
              {asyncStatus === FLOWS_SUCCESS && (
                <div className="wizard__form-wrapper">
                  {page === 1 && <WizardFormOne onSubmit={this.nextPage} asyncData={asyncData} />}
                  {page === 2 && (
                    <WizardFormTwo previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 3 && (
                    <WizardFormThree previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 4 && (
                    <WizardFormFour previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 5 && <WizardFormFive previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 6 && (
                    <WizardFormSix previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 7 && <WizardFormSeven previousPage={this.previousPage} />}
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  asyncData: state.flows.asyncData,
  asyncStatus: state.flows.asyncStatus,
  submitStatus: state.flows.submitStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getAsyncData: () => dispatch(getAsyncDataAction()),
  flowClearState: () => dispatch(flowClearStateAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(WizardForm)));
